module.exports = __webpack_public_path__ + "img/qiancai-back-phone@3x.873ba73c.png";